<template>
  <div class="content" >
    <WebHeader menu='4' ></WebHeader>
    <div class="web-page">
      <div class="imgdiv">
        <img src="static/img/socialRecruitment/socialHeaderImage.jpg">
      </div>
      <div class="block-title">
        <div></div>
        <div>社会招聘</div>
        <div></div>
      </div>
      <div class="filter-block">
        <div class="filter-screen">
          <div>
            <div>
              <img class="filter-screen-icon" src="static/img/socialRecruitment/shaixuan@3x.png">
              <p class="filter-text">筛选</p>
            </div>
<!--            US202509025 lmg  跳转链接修改 原:https://jobs.gecareers.com/healthcare/global/en/-->
            <div class="filter-more filter-more-small" @click="toLink('https://careers.gehealthcare.com/global/en')">
              查看更多<img src="static/img/socialRecruitment/xiangzuox.png"/>
            </div>
          </div>
          <div class="van-filter">
            <div class="filterDiv" :class="selectedCity==item?'sel':''" @click="setCity(item)"
                 v-for="(item,index) in cityList" :key="index">{{item}}</div>
          </div>
        </div>
        <div class="filter-more filter-more-big" @click="toLink('https://careers.gehealthcare.com/global/en')">
          查看更多<img src="static/img/socialRecruitment/xiangzuox.png"/>
        </div>
      </div>
      <div class='table-area'>
        <el-table  :data="typeList" stripe style="table-layout:fixed" :header-cell-style="{'text-align':'left'}">
          <el-table-column label="id" align="left" prop="dictId" v-if="false" />
          <el-table-column min-width="22%" label="Job Number" align="left" prop="jobNumber" :show-overflow-tooltip="true" style="word-wrap:break-word;white-space: pre-wrap"/>
          <el-table-column min-width="24%" label="Business" align="left" prop="business"  style="word-wrap:break-word;white-space: pre-wrap"/>
          <el-table-column min-width="38%" label="Position Title" align="left" prop="positionTitle" style="word-wrap:break-word;white-space: pre-wrap"/>
          <el-table-column min-width="20%" label="Location" align="left" prop="location" style="word-wrap:break-word;white-space: pre-wrap"/>
        </el-table>
        <div class="replenish">
          <div class="notice">
            <img src="static/img/socialRecruitment/xiaolaba@3x.png" class="notice-icon">
            <p class="labaP">更多热门职位,等待您的加入!</p>
          </div>
          <el-pagination @size-change="handleSizeChange"
                         :pager-count="7"
                         :page-size="12"
                         :current-page.sync="currentPage"
                         @current-change="handleCurrentChange"
                         layout="->,pager"
                         :total="total">
          </el-pagination>
        </div>
      </div>
    </div>
    <top-button></top-button>
    <WebFooter></WebFooter>
<!--    <webLoading></webLoading>-->
  </div>
</template>
<script>
  // window.onload = function () {
  //   document.getElementById('pageLoading').remove();
  // }
  import { getList } from "@/api/product";
  import TopButton from "../../components/web/topButton";
  export default {
    name: "SocialRecruitment",
    components: {TopButton},
    data() {
      return {
        // 遮罩层
        loading: true,
        // 选中数组
        ids: [],
        // 非单个禁用
        single: true,
        // 非多个禁用
        multiple: true,
        // 显示搜索条件
        showSearch: true,
        // 总条数
        total: 400,
        currentPage: 1,
        // 字典表格数据
        typeList: [
          // {dictId:1,jobNumber:'R3673757',business:'HC Private',positionTitle:'Senior Account Sales',location:'Shenyang'},
          // {dictId:2,jobNumber:'R3673470',business:'HC Private',positionTitle:'Senior Account Sales',location:'Hefei'},
          // {dictId:3,jobNumber:'R3673908',business:'HC Private',positionTitle:'Senior Account Sales',location:'Guangzhou'},
          // {dictId:4,jobNumber:'R3673759',business:'HC Private',positionTitle:'Senior Account Sales',location:'Chengdu'},
          // {dictId:5,jobNumber:'R3673801',business:'HC Private',positionTitle:'Senior Account Sales',location:'Guiyang/Kunming'},
          //
          // {dictId:3,jobNumber:'R3673428',business:'HC Private',positionTitle:'Senior Account Sales',location:'Zhengzhou'},
          // {dictId:3,jobNumber:'R3673462',business:'HC Private',positionTitle:'Senior Account Sales',location:'Zhengzhou'},
          // {dictId:3,jobNumber:'R3674862',business:'HC Private',positionTitle:'Enterprise Key Account Sales',location:'Shanghai'},
          // {dictId:3,jobNumber:'R3673726',business:'HC Ultrasound',positionTitle:'Channel Sales Leader',location:'Nanjing'},
          // {dictId:3,jobNumber:'R3673723',business:'HC Ultrasound',positionTitle:'Channel Sales Leader',location:'Nanchang'},
          // {dictId:3,jobNumber:'R3673728',business:'HC Ultrasound',positionTitle:'Channel Sales Leader',location:'Shijiazhuang/Taiyuan'},
          // {dictId:3,jobNumber:'R3673781',business:'HC Ultrasound',positionTitle:'Channel Sales Leader',location:'Shenzhen'}
        ],
        // 查询参数
        queryParams: {
          pageNum: 1,
          pageSize: 2,
          dictName: undefined,
          dictType: undefined,
          status: undefined
        },
        cityList: ['北京','上海','无锡','广州','其他'],
        selectedCity: null,
        //rowStyle:{height:'120px'}
        queryParams: {
          pageNum: 1,
          pageSize: 12,
          httpType: 'shezhao',
          city: null
        }
      }
    },
    created() {
      this.selectedCity=this.cityList[0];
      this.queryParams.city=this.cityList[0];
      this.getList();
    },
    methods: {
      /** 查询字典类型列表 */
      getList() {
        getList(this.queryParams).then(response => {
          console.log(response.data);
          this.typeList=response.data.rows;
          this.total=response.data.total;
        });
        this.loading = false;
      },
      handleSizeChange(val) {
        console.log(`每页 ${val} 条`);
      },
      handleCurrentChange(val) {
        console.log(`当前页: ${val}`);
        this.queryParams.pageNum=val;
        this.getList();
      },
      triggerClick(e){
        console.log(e)
      },
      rowStyle({ row, rowIndex}) {
        return 'height:12px'
      },
      setCity(e){
        this.selectedCity=e;
        this.queryParams.city=e;
        this.queryParams.pageNum=1;
        this.currentPage = 1;
        this.getList();
      },
      toLink(link){
        window.open(link,'_blank');
      }

    }
  }
</script>

<style scoped>

  /*筛选部分开始*/
  .filter-block{
    width: 65%;
    margin: 0 auto 37px;
    display: flex;
    align-items: center;
    justify-content: space-between;
  }
  .filter-more-small{
    display: none;
  }
  .filter-more-big{
    display: flex;
  }
  .filter-block .filter-screen{
    display: flex;
    align-items: center;
  }
  .filter-block .filter-screen > div > div:first-child {
    display: flex;
  }
  .filter-block .filter-screen-icon{
    width: 37px;
    height: 38px;
  }
  .filter-block .filter-text{
    font-size: 32px;
    font-weight: 600;
    color: rgb(100,0,160);
    margin: 0 53px 0 21px;
  }
  .filter-block .van-filter{
      display: flex;
  }
  .van-filter .sel {
    background-color: rgb(100,0,160);
    color: #ffffff;
  }
  .van-filter > div{
     font-size: 20px;
     color: rgb(100,0,160);
     border: 2px solid rgb(100,0,160);
     border-radius: 8px;
     padding: 11px 22px;
    margin-right: 19px;
    cursor:pointer;
  }
  .table-area{
    width: 65%;
    margin: 0 auto;
  }
  .imgdiv{
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .imgdiv img{
    width: 100%;
    height: auto;
  }

  .block-title {
    padding-top: 50px;
    padding-bottom: 40px;
  }
  .filter-block .filter-more{
    padding: 0 10px;
    height: 42px;
    border-radius: 8px;
    background: rgb(100,0,160);
    color: #ffffff;
    font-size: 18px;
    justify-content: center;
    align-items: center;
    font-weight: 600;
    letter-spacing: 1px;
    cursor:pointer;
  }
  .filter-block .filter-more img{
    width: 9px;
    height: 17px;
    margin: 0 0 0 9px;
  }

  .table-area  .replenish{
    width: 100%;
    margin: 16px 0 229px ;
  }
  .table-area .replenish .notice{
    display: flex;
    align-items: center;
    margin: 34px 0 0;
  }
  .table-area .replenish .notice-icon{
    width: 34px;
    height: 29px;
    margin: 0 8px 0 0 ;
  }


  @media  screen and  (max-width: 1380px) {
    .filter-more-small{
      display: flex;
    }
    .filter-more-big{
      display: none;
    }
    .filter-block{
      width: 80vw;
      align-items: flex-start;
    }
    .filter-block .filter-screen{
      display: flex;
      flex-direction: column;
      align-items: start;
    }
    .filter-block .filter-screen > div:first-child{
      display: flex;
      justify-content: space-between;
      align-items: center;
      width: 80vw;
    }
    .filter-block .filter-screen > div:last-child{
      margin:  20px 0 0 0;
      width: 80vw;
    }
    .table-area{
      width: 80vw;
      margin: 0 auto;
    }
    .filter-block .van-filter{
      display: flex;
    }
  }
  @media screen and  (max-width: 869px) {
    .table-area  .replenish{
      display: flex;
      flex-direction: column-reverse;
      align-items: flex-start;
    }
    .table-area{
      width: 90vw;
    }
    .filter-block{
      width: 90vw;
      align-items: flex-start;
    }
    .filter-block .filter-screen > div:first-child{
      display: flex;
      justify-content: space-between;
      align-items: center;
      width: 90vw;
    }
    .filter-block .filter-screen > div:last-child{
      margin:  20px 0 0 0;
      width: 90vw;
    }
    .filter-block .filter-screen-icon{
      width: 22px;
      height: 23px;
    }
    .filter-block .filter-text{
      font-size: 19px;
      font-weight: 600;
      color: rgb(100,0,160);
    }
    .filter-block .van-filter > div{
      font-size: 12px;
      /*color: rgb(100,0,160);*/
      border: 2px solid rgb(100,0,160);
      border-radius: 8px;
      padding: 7px 13px;
      margin-right: 11px;
    }
    .filter-block .filter-more{
      width: 68px;
      height: 25px;
      border-radius: 5px;
      font-size: 12px;
    }
    .filter-block .filter-more img{
      width: 5px;
      height: 10px;
      margin: 0 0 0 4px;
    }
    .table-area .replenish .notice-icon{
      width: 20px;
      height: 17px;
      margin: 0 8px 0 0 ;
    }
  }

  @media screen and  (max-width: 430px) {
    .filter-block .van-filter{
      flex-wrap: wrap;
      justify-content: space-between;
    }
    .filter-block .van-filter > div{
      margin: 0 0 10px 0;
    }
  }
</style>
<style>

  .el-table--enable-row-transition .el-table__body td.el-table__cell{
    padding-left: 10px;
  }

  .table-area .el-table tbody td .cell {
    word-break: break-word;
    white-space: pre-wrap;

  }
 .table-area .el-table thead  th.el-table__cell{
    background-color: #E8E8E8;
   font-size: 30px;
   height: 90px;
   color: #333333;
  }
 .table-area .el-table  thead  th .cell{
   line-height: 52px;
  }
 .table-area .el-table  tbody  td .cell{
   font-size: 22px;
   line-height: 24px;
   color: #333333;
   padding: 22px 0;
  }

 .table-area .el-pager li{
   margin: 0 24px 0 0;
 }
 .table-area .el-pager .number {
   background: #ffffff;
   border: 1px solid rgb(100,0,160);
   border-radius: 4px;
   min-width: 38px;
   height: 38px;
   line-height: 38px;
   color: rgb(100,0,160);
 }
 .table-area .el-pager .active {
   background: rgb(100,0,160);
   color: #FFFFFF;
 }
 .table-area .number:hover {
   background: rgb(100,0,160);
   color: #FFFFFF;
 }

 @media  screen and  (max-width: 1380px) {
   .table-area .el-table thead  th.el-table__cell{
     font-size: 26px;
   }
   .table-area .el-table  thead  th .cell{
     line-height: 45px;
   }
   .table-area .el-table  tbody  td .cell {
     font-size: 18px;
     line-height: 22px;
     padding: 16px 0;
   }
 }
 @media  screen and  (max-width: 869px) {
   .table-area .el-table thead  th.el-table__cell{
     font-size: 16px;
   }
   .table-area .el-table  thead  th .cell{
     line-height: 25px;
   }
   .table-area .el-table  tbody  td .cell {
     font-size: 13px;
     line-height: 16px;
     padding: 14px 0;
   }
   .table-area .el-table{
     width: 100%;
     font-size: 21px;
     color: #333333;
   }
   .table-area .el-pager .number {
     background: #F7F7FA;
     border: 1px solid #C4B5D6;
     border-radius: 4px;
     min-width: 26px;
     height: 26px;
     line-height: 26px;
     color: #B5B5D6;
   }
   .table-area .el-pager .active {
     background: rgb(100,0,160);
     color: #FFFFFF;
   }
   .table-area .el-pager li{
     margin: 0 12px 0 0;
   }

 }
 .filter-block .van-filter > div:hover{
   background-color: rgb(100,0,160);
   color: #ffffff;
 }

 .filter-block  .filter-more:hover{
   background-color: rgb(100,0,160);
   text-decoration: underline;
 }
  .table-area .el-table tbody td .cell{
    word-break: break-word;
    white-space: pre-wrap;
  }
</style>



// WEBPACK FOOTER //
// src/views/web/socialRecruitment.vue